import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-582c3ed0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-view"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "el-dropdown-link"
}, " 选项 ", -1));
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  key: 0,
  class: "h_left"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jia"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实时大屏 ", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chanpincanshu"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "平台统计", -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangpin"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商城统计", -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-file-add"
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品流向", -1));
const _hoisted_16 = [_hoisted_14, _hoisted_15];
const _hoisted_17 = {
  key: 1,
  class: "h_right"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jingpaicaigoushang"
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "采购商", -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-gongyingshang"
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "供应商", -1));
const _hoisted_23 = [_hoisted_21, _hoisted_22];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-icon-order-plan"
}, null, -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "品牌分析", -1));
const _hoisted_26 = [_hoisted_24, _hoisted_25];
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-icon-order-plan"
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "区域分析", -1));
const _hoisted_29 = [_hoisted_27, _hoisted_28];
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h_centre"
}, [/*#__PURE__*/_createElementVNode("p", null, "方舟控股 集药方舟药品供应链")], -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jia"
}, null, -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回首页", -1));
const _hoisted_33 = [_hoisted_31, _hoisted_32];
const _hoisted_34 = {
  class: "main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
    "hide-on-click": false,
    class: "logout"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      onClick: _ctx.ElDropdown
    }, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        "data-index": "1"
      }, {
        default: _withCtx(() => [_createTextVNode("药城搜索")]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        "data-index": "2"
      }, {
        default: _withCtx(() => [_createTextVNode("退出")]),
        _: 1
      })]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_ctx.issearch !== true ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("ul", null, [_createElementVNode("li", {
    class: _normalizeClass({
      'active': $setup.hactive == 'realtime'
    }),
    onClick: _cache[0] || (_cache[0] = $event => $setup.bindheader('realtime'))
  }, _hoisted_7, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'platform'
    }, {
      active: $setup.hactive == 'platform2'
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $setup.bindheader('platform'))
  }, _hoisted_10, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      'active': $setup.hactive == 'shopping'
    }, {
      'active': $setup.hactive == 'shopping2'
    }, {
      'active': $setup.hactive == 'shopping3'
    }, {
      'active': $setup.hactive == 'shopping4'
    }, {
      'active': $setup.hactive == 'shopping5'
    }]),
    onClick: _cache[2] || (_cache[2] = $event => $setup.bindheader('shopping'))
  }, _hoisted_13, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'product'
    }, {
      active: $setup.hactive == 'product2'
    }]),
    onClick: _cache[3] || (_cache[3] = $event => $setup.bindheader('product'))
  }, _hoisted_16, 2)])])) : _createCommentVNode("", true), _ctx.issearch !== true ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("ul", null, [_createElementVNode("li", {
    class: _normalizeClass([{
      'active': $setup.hactive == 'purchaser'
    }, {
      'active': $setup.hactive == 'purchaser2'
    }]),
    onClick: _cache[4] || (_cache[4] = $event => $setup.bindheader('purchaser'))
  }, _hoisted_20, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'supplier'
    }, {
      active: $setup.hactive == 'supplier2'
    }]),
    onClick: _cache[5] || (_cache[5] = $event => $setup.bindheader('supplier'))
  }, _hoisted_23, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'brand'
    }, {
      active: $setup.hactive == 'brand2'
    }]),
    onClick: _cache[6] || (_cache[6] = $event => $setup.bindheader('brand'))
  }, _hoisted_26, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'regional'
    }, {
      active: $setup.hactive == 'regional2'
    }]),
    onClick: _cache[7] || (_cache[7] = $event => $setup.bindheader('regional'))
  }, _hoisted_29, 2)])])) : _createCommentVNode("", true), _hoisted_30, _ctx.issearch ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "homepage",
    onClick: _cache[8] || (_cache[8] = (...args) => _ctx.goRealTime && _ctx.goRealTime(...args))
  }, _hoisted_33)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_router_view)])]);
}